<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Attendance Reconciliation Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2 justify-items-between">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/attendance/reconciliation-setup')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add Reconciliation
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >

                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                    v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                    color="yellow-darken-3"
                    size="small"
                    >
                        Wating for {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                    v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                    color="green"
                    size="small"
                    >
                        Approved By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    
                    <v-chip
                    v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                    color="red"
                    size="small"
                    >
                        Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                    v-else
                    color="green"
                    size="small"
                    >
                    {{ item.approval_status }}
                    </v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      color="orange"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath)"
                    />
                    
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

  <input
    ref="csvInput"
    type="file"
    style="display: none"
    @change="handleCSVFile"
  />
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";

export default {
  components: {},
  
  data: () => ({
    itemsPerPage: "-1",
    panel: [0],
    search: "",
    dialog: false,
    data: {},
    loading: false,
    headers: [
      { title: "#SL", align: "center", key: "id", sortable: false, width: "50px" },
      { title: "Employee Name", key: "employee.name", align: "left", sortable: false },
      { title: "Code", key: "employee.code", align: "left", sortable: false },
      { title: "Designation", key: "employee.designation.name", align: "left", sortable: false },
      { title: "Department", key: "employee.department.name", align: "left", sortable: false },
      { title: "Reconciliation Date", key: "date", align: "left", sortable: false },
      { title: "In Time", key: "actual_in", align: "left", sortable: false },
      { title: "Out Time", key: "actual_out", align: "left", sortable: false },
      { title: "In Time Remarks", key: "in_remarks", align: "left", sortable: false, },
      { title: "Out Time Remarks", key: "out_remarks", align: "left", sortable: false, },
      { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
      { title: "Status", key: "status", align: "left", sortable: false },
      { title: "Actions", align: "left", key: "actions", sortable: false },
    ],
  }),
  watch: {},

  created() {
    if(this.$store.getters.getAttendanceReconciliationList.length == 0){
      this.loading = true;
      this.$store.dispatch('getAttendanceReconciliationList').then((response) => {
          this.loading = false;
      })
    };
  },

  computed: {
    getSchema() {
      return this.$store.getters.getAttendanceReconciliationList;
    },

  },

  setup() {},

  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },

    editItem(item) {
      this.$store.commit("SET_EDITING_ATTENDANCE_RECONCILIATION", item);
      console.log(this.$store.getters.getEditingAttendanceReconciliation);
      this.$router.push({ name: "reconciliation-setup" });
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Employee Name", "Date", "In Time", "Out Time", "In Time Remarks", "Out Time Remarks", "Status", ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.employee.name, item.date, item.actual_in, item.actual_out, item.in_remarks, item.out_remarks, item.status == 1 ? "Active" : "Inactive" ]);
      this.$exportTableToPDF( columns, rows, "Attendance Reconciliation List", "attendance_reconciliation_list_" + this.$fileDate() );
    },

    exportToExcel() {
      var data = [[ "#SL", "Employee Name", "Date", "In Time", "Out Time", "In Time Remarks", "Out Time Remarks", "Status", ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.employee.name, item.date, item.actual_in, item.actual_out, item.in_remarks, item.out_remarks, item.status == 1 ? "Active" : "Inactive", ]);
      });
      this.$exportTableToExcel(data, "attendance_reconciliation_list_" + this.$fileDate());
    },

    exportToCSV() {
      var data = [[ "#SL", "Employee Name", "Date", "In Time", "Out Time", "In Time Remarks", "Out Time Remarks", "Status", ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.employee.name, item.date, item.actual_in, item.actual_out, item.in_remarks, item.out_remarks, item.status == 1 ? "Active" : "Inactive" ]);
      });

      this.$exportTableToCSV(data, "attendance_reconciliation_list_" + this.$fileDate());
    },
  },

  mounted() {},  
};
</script>
